<div class="page-wrapper suppliers-page"  #containerSuppliers>
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div>
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Fournisseurs
        </div>
      </div>
    </div>
  </div>
  <div class="suppliers-page-inner">
    <div class="container">
      <h2 class="title d-flex align-items-center gap-2">LES FOURNISSEURS</h2>
      <div class="filter-export d-flex flex-wrap justify-content-between gap-2 align-items-center">
        <div class="wrap-input">
          <label for="">Raison sociale</label>
          <input (focusout)="emptyList()" [(ngModel)]="searchSupplier" (keyup)="onSearchInput()"
            [ngModelOptions]="{standalone: true}" type="text" placeholder="Rechercher un fournisseur" />
          <button (click)="filterCompany()" class="btn-search">
            <img src="src-adisco/assets/images/icon/Icon open-magnifying-glass.svg" alt=""></button>
          <div class="autocomplete-list" *ngIf="autocompleteSearchlistSuppliers.length > 0">
            <ul class="p-0" style="list-style: none">
              <li class="ac-li" *ngFor="let item of autocompleteSearchlistSuppliers" (click)="selectItem(item)">
                {{item.companyName}}
              </li>
            </ul>
          </div>
        </div>
        <button *ngIf="userService.hasExtranetAccess('fonctions', 'export-fournisseurs')" class="btn-common btn-export"
          (click)="onExport()">EXPORTER</button>
      </div>
      <div class="wrap-pagi">
        <form [formGroup]="formPagination" class="">
          <div *ngIf="totalPages > 0" class="wrap-pagination">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="wrap-rows">
                Afficher
                <p-dropdown formControlName="rows" (onChange)="filterRows()" class="item-page" [options]="listRows"
                  optionLabel=""></p-dropdown>éléments
              </div>
              <p-paginator *ngIf="totalPages > 1" #paginator1 [ngClass]="{'show-dot': totalPages > 5 }"
                (onPageChange)="onPageChange($event)" [rows]="rows3" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="false"></p-paginator>
            </div>
          </div>
        </form>
      </div>
      <div class="list-suppliers d-flex relative">
        <div *ngFor="let supplier of listSuppliers" class="supplier">
          <div class="wrap-general-info d-flex align-items-center mb-2">
            <div class="wrap-img">
              <img *ngIf="supplier?.logo" class="" src="{{ supplier?.logo[0]?.url }}" alt="" />
              <img *ngIf="!supplier?.logo" class="" src="src-adisco/assets/images/image-default.jpeg" alt="" />
            </div>
            <div class="general-info">
              <p class="name mb-0">{{ supplier?.companyName }}</p>
              <p class="mb-0">
                Téléphone : <span>{{ supplier.phone ? supplier.phone : '-'}}</span>
              </p>
              <p class="mb-0">
                Fax : <span>{{ supplier.fax ? supplier.fax : '-'}}</span>
              </p>
              <p class="mb-0">
                Email : <span>{{ supplier.email ? supplier.email : '-' }}</span>
              </p>
              <p class="mb-0">
                Ville : <span>{{ getSupplierVille(supplier) }}</span>
              </p>
            </div>
          </div>
          <div class="group-btn d-flex justify-content-between align-items-center">
            <button routerLink="/suppliers/detail-supplier/{{ supplier?.code }}" class="btn-common">VOIR LA
              FICHE</button>
            <button routerLink="/catalogues/suppliers/{{supplier?.code}}" class="btn-common">CATALOGUE</button>
          </div>
        </div>
        <div class="loading" *ngIf="loadingStatus">
          <img src="/src-adisco/assets/images/icon/loading.gif" alt="">
        </div>
      </div>
      <div class="wrap-pagi">
        <form [formGroup]="formPagination" class="">
          <div *ngIf="totalPages > 0" class="wrap-pagination">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="wrap-rows">
                Afficher
                <p-dropdown formControlName="rows" (onChange)="filterRows()" class="item-page" [options]="listRows"
                  optionLabel=""></p-dropdown>éléments
              </div>
              <p-paginator *ngIf="totalPages > 1" #paginator2 [ngClass]="{'show-dot': totalPages > 5 }"
                (onPageChange)="onPageChange($event)" [rows]="rows3" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="false"></p-paginator>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ng-container *ngIf="loading">
    <div class="overlay-loading">
        <p-progressSpinner
            styleClass="w-4rem h-4rem"
            strokeWidth="5"
            fill="var(--surface-ground)"
            animationDuration=".5s"
        ></p-progressSpinner>
    </div>
    </ng-container>
</div>
